class PrePasswordPage extends HTMLElement {
  connectedCallback() {
    this.scrollButton = this.querySelector('[data-scroll-button]');
    this.initScrollButton = this.initScrollButton.bind(this);
    this.initScrollButton();
  }

  initScrollButton() {
    if (!this.scrollButton) {
      return;
    }

    this.scrollButton.addEventListener('click', () => {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    });
  }
}

if (!customElements.get('pre-password-page')) {
  customElements.define('pre-password-page', PrePasswordPage);
}